import { render } from "./index.vue?vue&type=template&id=67fe8bf4&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=67fe8bf4&lang=scss&scoped=true"

import exportComponent from "/data/fe-node-modules/beta-ab/candao-h5-v6-phd/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67fe8bf4"]])

export default __exports__